import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Loader2 } from 'lucide-react';
import { StatusDot } from '@/components/Page';

// Sistema E: título neutro; a cor fica só no botão que executa a ação.
const ACAO = {
  destructive: 'bg-red-600 text-white hover:bg-red-700',
  warning: 'bg-amber-600 text-white hover:bg-amber-700',
  info: '',
};

const ConfirmDialog = ({
  open,
  onOpenChange,
  title = 'Tem certeza?',
  description = 'Esta ação não pode ser desfeita.',
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  onConfirm,
  loading = false,
  variant = 'destructive',
  details,
  warningList,
  onCloseAutoFocus, // opcional: para onde vai o foco ao fechar (sem Trigger do Radix ele cairia no <body>)
}) => {

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent onCloseAutoFocus={onCloseAutoFocus}>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>

        {details && (
          <div className="space-y-2 rounded-lg bg-sheet2 p-4">
            {details.map((item, idx) => (
              <div key={idx} className="flex items-center justify-between text-sm">
                <span className="text-gray-600 dark:text-gray-400">{item.label}:</span>
                <span className="font-medium tabular-nums">{item.value}</span>
              </div>
            ))}
          </div>
        )}

        {warningList && warningList.length > 0 && (
          <div className="rounded-lg bg-sheet2 p-3">
            <StatusDot tone="att" className="font-medium">Atenção</StatusDot>
            <ul className="mt-2 list-disc space-y-1 pl-[31px] text-sm text-gray-600 dark:text-gray-300">
              {warningList.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          </div>
        )}

        <AlertDialogFooter>
          <AlertDialogCancel disabled={loading}>{cancelText}</AlertDialogCancel>
          <AlertDialogAction
            onClick={(e) => {
              e.preventDefault();
              if (!loading) onConfirm?.();
            }}
            disabled={loading}
            className={ACAO[variant] ?? ACAO.destructive}
          >
            {loading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Processando
              </>
            ) : (
              confirmText
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ConfirmDialog;
